import { useState, useRef, useEffect } from 'react'

export default function CmsAgent() {
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState([
    { role: 'bot', text: '你好！我是 CMS 助手 🤖\n可以问我：线索、订单、用户、统计...' }
  ])
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const endRef = useRef(null)

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }) }, [messages])

  const send = async () => {
    const q = input.trim()
    if (!q || loading) return
    setInput('')
    setMessages(prev => [...prev, { role: 'user', text: q }])
    setLoading(true)
    try {
      const res = await fetch('/api/cms-agent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: q })
      })
      const data = await res.json()
      setMessages(prev => [...prev, { role: 'bot', text: data.response || data.message || '出错了' }])
    } catch (e) {
      setMessages(prev => [...prev, { role: 'bot', text: '网络错误: ' + e.message }])
    }
    setLoading(false)
  }

  const quickBtns = ['线索', '订单', '用户', '统计']

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed', bottom: 20, right: 20, zIndex: 9999,
          width: 52, height: 52, borderRadius: '50%',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer',
          boxShadow: '0 4px 15px rgba(102,126,234,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
        title="AI 助手"
      >
        🤖
      </button>
    )
  }

  return (
    <div style={{
      position: 'fixed', bottom: 20, right: 20, zIndex: 9999,
      width: 360, height: 480,
      background: '#fff', borderRadius: 12,
      boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
      display: 'flex', flexDirection: 'column', overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '12px 16px', background: 'linear-gradient(135deg, #667eea, #764ba2)',
        color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <span style={{ fontWeight: 'bold' }}>🤖 CMS 助手</span>
        <button onClick={() => setOpen(false)} style={{
          background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer'
        }}>✕</button>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflow: 'auto', padding: 12 }}>
        {messages.map((m, i) => (
          <div key={i} style={{
            marginBottom: 8,
            display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start'
          }}>
            <div style={{
              maxWidth: '80%', padding: '8px 12px', borderRadius: 10,
              background: m.role === 'user' ? '#667eea' : '#f0f0f0',
              color: m.role === 'user' ? '#fff' : '#333',
              fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.5
            }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && <div style={{ color: '#999', fontSize: 12, padding: 4 }}>查询中...</div>}
        <div ref={endRef} />
      </div>

      {/* Quick buttons */}
      <div style={{ padding: '4px 12px', display: 'flex', gap: 6 }}>
        {quickBtns.map(b => (
          <button key={b} onClick={() => { setInput(b); send() }}
            style={{
              padding: '4px 10px', borderRadius: 12, border: '1px solid #ddd',
              background: '#fafafa', fontSize: 12, cursor: 'pointer', color: '#666'
            }}
          >{b}</button>
        ))}
      </div>

      {/* Input */}
      <div style={{ padding: '8px 12px', borderTop: '1px solid #eee', display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder="输入问题..."
          style={{
            flex: 1, border: '1px solid #ddd', borderRadius: 8,
            padding: '8px 12px', fontSize: 13, outline: 'none'
          }}
        />
        <button onClick={send} disabled={loading} style={{
          padding: '8px 16px', borderRadius: 8, border: 'none',
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          color: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
          fontSize: 13, opacity: loading ? 0.6 : 1
        }}>发送</button>
      </div>
    </div>
  )
}
